<template>
  <div class="edit_user">
    <pcHeader></pcHeader>
    <div class="edit_user_info">
      <van-form class="upload_works_flex" ref="form">
        <van-field name="uploader" class="form_center">
          <template #input>
            <van-uploader :max-count="1" v-model="fileList" :after-read="afterRead"> </van-uploader>
          </template>
        </van-field>

        <div class="field">
          <div class="field_box">
            <van-field
              @input="blurRules"
              @blur="blurRulesTwo"
              v-model="userInfo.nickName"
              :label="$t('message.user.alias')"
              :placeholder="$t('message.login.name_plase')"
              :rules="[{ required: true, message: $t('message.login.name_null') }]"
              class="text_input name"
            />
            <van-field class="sex" name="radio" :label="$t('message.user.gender')">
              <template #input>
                <van-radio-group v-model="userInfo.sex" direction="horizontal">
                  <van-radio :name="0" style="margin-right: 66px; margin-left: 30px">{{
                    $t('message.user.male')
                  }}</van-radio>
                  <van-radio :name="1">{{ $t('message.user.female') }}</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <!-- <van-field
              v-model="userInfo.phone"
              type="number"
              :label="$t('message.user.phonenumber')"
              :placeholder="$t('message.user.pleasenumber')"
              show-word-limit
              :rules="telRules"
              class="text_input name"
            /> -->

            <VuePhoneNumberInput
              v-model="phone"
              @update="validate"
              :translations="translations"
              class="phoneNumber"
              :preferred-countries="['CN', 'US', 'CA', 'TH', 'KH', 'PT', 'MY', 'JP']"
            />

            <van-field
              v-model="userInfo.address"
              :label="$t('message.user.address')"
              placeholder="请输入"
              class="text_input"
            />
          </div>
        </div>
      </van-form>
    </div>
    <div class="btn">
      <van-button @click="btn" class="btn1">保存</van-button>
    </div>
  </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import pcHeader from '../../../../components/pcHeader'
import { Toast } from 'vant'
const defaultInfo = Object.freeze({
  address: '',
  awards: 0,
  city: '',
  cityName: '',
  countries: '',
  district: '',
  headImgUrl: '',
  identificationBack: '',
  identificationFront: '',
  identificationNumber: '',
  identificationValidityPeriod: '',
  ip: '',
  loginDate: '',
  nickName: '',
  phone: '',
  provinces: '',
  realName: '',
  sex: 0,
  source: '',
  userOnlySign: '',
  works: 0,
  mobile: ''
})
import { upLoadImg } from '@/api/common'
import { apiUser, updateUser, sendRequest } from '@/api/user.js'
export default {
  name: 'EditUser',
  data() {
    return {
      fileList: [],
      telRules: [
        {
          required: true,
          message: this.$t('message.user.phone_null'),
          trigger: 'onBlur'
        },
        {
          // 自定义校验规则
          validator: (value) => {
            return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57]|19[0-9])[0-9]{8}$/.test(
              value
            )
          },
          message: this.$t('message.user.rulesph'),
          trigger: 'onBlur'
        }
      ],
      userInfo: { ...defaultInfo },
      translations: {},
      phone: '',
      sensitiveWord: false
    }
  },
  components: {
    pcHeader,
    VuePhoneNumberInput
  },
  created() {
    if (sessionStorage.getItem('lang') == 'zhcn') {
      this.translations = {
        countrySelectorLabel: '国家',
        phoneNumberLabel: '手机号码'
      }
    } else {
      this.translations = {}
    }
    this.getUser()
  },
  methods: {
    async blurRules() {
      const { data: res } = await sendRequest({
        key: this.userInfo.nickName
      })
      if (res.data) {
        this.sensitiveWord = true
      } else {
        this.sensitiveWord = false
      }
    },
    async blurRulesTwo() {
      const { data: res } = await sendRequest({
        key: this.userInfo.nickName
      })
      if (res.data) {
        return Toast('您当前昵称存在敏感词，请修改后重试')
      }
    },
    validate(val) {
      console.log(val)
      this.userInfo.phone = val.formattedNumber
      this.userInfo.mobile = val.nationalNumber
    },
    async submitClick() {
      if (this.sensitiveWord) {
        return Toast('您当前昵称存在敏感词，请修改后重试')
      }
      // console.log(this.userInfo.phone);
      // console.log(this.userInfo.mobile);
      // console.log(this.userInfo)
      if (this.phone == null || this.phone == '' || this.phone == undefined) {
        return Toast('请填写手机号')
      }
      const { data: res } = await updateUser(this.userInfo)
      if (res.resultCode === 200) {
        Toast.success(this.$t('message.user.sub_succ'))
        Object.assign(this.userInfo, defaultInfo)
        this.$router.go(-1)
      } else {
        Toast.fail(this.$t('message.user.sub_later'))
      }
    },
    btn() {
      this.$refs.form
        .validate()
        .then(() => {
          this.submitClick()
        })
        .catch(() => {
          this.$toast.fail(this.$t('message.user.com_mation'))
        })
    },
    //上传图片
    async afterRead(file) {
      const form = new FormData()
      form.append('file', file.file)
      const { data: res } = await upLoadImg(form)
      if (res.resultCode === 200) {
        this.userInfo.headImgUrl = res.data.fileLook
      }
    },
    async getUser() {
      const { data: res } = await apiUser()
      if (res.resultCode === 200) {
        this.userInfo = res.data
        this.phone = res.data.phone
        if (this.userInfo.headImgUrl) {
          this.fileList.push({
            name: '头像',
            url: this.userInfo.headImgUrl,
            isImage: true
          })
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.edit_user {
  width: 100%;
  height: 100vh;
  // overflow: scroll;

  .edit_user_info {
    height: 100vh;
    // overflow: scroll;
  }
  .btn {
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    position: fixed;
    bottom: 30px;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 20px;
    // background-color: #fff;
    text-align: center;

    .btn1 {
      width: 240px;
      height: 36px;
      margin: 0 20px;
      line-height: 36px;
      text-align: center;
      padding: 0;
      border: none;
      background: linear-gradient(301.69deg, #6688ff 13.72%, #3360ff 67.35%);
      box-shadow: 0px 0px 12px rgba(255, 192, 21, 0.2);
      border-radius: 16px;
      color: #fff;
      font-size: 14px;
      font-weight: 400;
      border-radius: 16px;
    }
  }

  .upload_works_flex {
    width: 100%;
    // overflow: hidden;
    padding-top: 38px;

    /deep/ .van-uploader__preview-image {
      width: 72px;
      height: 72px;
      border-radius: 50%;
    }

    /deep/ .van-cell {
      display: flex;

      .van-cell__title {
        color: #1a1a1a;
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 10px;
      }
    }
    /deep/ .van-cell::after {
      border: 0px;
      content: '';
    }
  }

  .form_center {
    width: 100%;

    /deep/ .van-field__control--custom {
      margin: 0 auto;
      width: 72px;
    }

    /deep/.an-cell__value {
      text-align: center;
    }

    /deep/.van-uploader__upload {
      width: 72px;
      height: 72px;
      border-radius: 50%;
      position: relative;
    }
  }
}
.field {
  display: flex;
  justify-content: center;
  .field_box {
    width: 500px;
  }
}
.text_input {
  // justify-content: center;
  padding: 20px 16px;
  /deep/ .van-cell__value {
    border: 1px solid #efefef;
    width: 324px;
    height: 36px;
    flex: none;
  }
  /deep/.van-field__body {
    width: 100%;
    height: 100%;
  }

  /deep/.van-field__control {
    width: 100%;
    height: 100%;
    padding-left: 15px;
  }
  /deep/.van-cell__title {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: #999999 !important;
    margin-bottom: 0 !important;
  }
}
.name /deep/.van-cell__title span::before {
  content: '*';
  color: #e34747;
}
.sex {
  // justify-content: center;
  /deep/.van-cell__title {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: #999999 !important;
    margin-bottom: 0 !important;
  }
  /deep/.van-cell__value {
    flex: none;
  }
  /deep/.van-radio--horizontal {
    margin-left: 5px;
    margin-right: 27px !important;
  }
}

/deep/.country-selector__input {
  border-color: #ccc !important;
}
/deep/.country-selector__label {
  color: #747474 !important;
}
/deep/.input-tel__label {
  color: #747474 !important;
}
/deep/.input-tel__input {
  border-color: #ccc !important;
}
/deep/.flex-1 {
  width: 324px;
  flex: none;
}
</style>
